import packageJson from '../../package.json'

const app = packageJson.name

const set = (key: string, value: boolean|string) => {
  localStorage.setItem(`${app}-${key}`, `${value}`)
}

const remove = (key: string) => {
  localStorage.removeItem(`${app}-${key}`)
}

const getBoolean = (key: string): boolean => {
  return localStorage.getItem(`${app}-${key}`) === 'true'
}

const getString = (key: string): string|null => {
  return localStorage.getItem(`${app}-${key}`)
}

const setStringArray = (key: string, value: string[]) => {
  localStorage.setItem(`${app}-${key}`, JSON.stringify(value))
}

const getStringArray = (key: string): string[] => {
  return JSON.parse(localStorage.getItem(`${app}-${key}`) ?? '[]')
}

export const Storage = {
  set, remove, getBoolean, getString, setStringArray, getStringArray
}